module.exports = __webpack_public_path__ + "img/s-9.8a6b516c.jpg";